import React from 'react';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import Tiers from './Tiers';
import Seo from '../../components/Seo';

const Home: React.FC = () => (
  <div className="space-y-12">
    <Seo titleKey="seo.home_title" />
    <Hero />
    <HowItWorks />
    <Tiers />
  </div>
);

export default Home;
